import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from '../App';

export default function PsychologistPublicLink({ page }) {
  const [ownPage, setOwnPage] = useState(null);
  const [copied, setCopied] = useState(false);
  useEffect(() => {
    if (page === undefined) axios.get(`${API}/psychologist/public-page`).then(res => setOwnPage(res.data)).catch(() => {});
  }, [page]);
  const value = page === undefined ? ownPage : page;
  if (!value?.url) return null;
  return <div className="my-3 rounded border bg-blue-50 p-3 text-sm">
    <p className="font-semibold">Public INSIGHT Page</p>
    <p className="break-all my-1">{value.url}</p>
    <p className="text-xs mb-2">{value.enabled ? 'Available' : 'Unavailable'}</p>
    <button type="button" className="underline mr-4" onClick={async () => {
      try { await navigator.clipboard.writeText(value.url); setCopied(true); }
      catch { setCopied(false); }
    }}>{copied ? 'Copied' : 'Copy Link'}</button>
    <a className="underline" href={value.url} target="_blank" rel="noopener noreferrer">Open Public Page</a>
  </div>;
}
